import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-buy-home',
    templateUrl: './buy-home.component.html',
    styleUrls: ['./buy-home.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class BuyHomeComponent {

}
